import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeIndex: "1"
  },
  mutations: {
    updateactiveIndex(state, nowindex) {
      state.activeIndex = nowindex;
    }
  },
  actions: {}
});
